import styled from '@emotion/styled'

import { breakpoints } from '../../utils/styles'

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2.5rem;
  position: relative;
  padding: 2.5rem 2.5rem 0;
  max-width: 1400px;
  margin: 0 auto;

  // .product:nth-child(2) {
  //   margin-top: 5rem;
  // }
  //
  // .product:nth-child(3) {
  //   margin-top: -5rem;
  // }

  @media (max-width: ${breakpoints.s}px) {
    grid-template-columns: repeat(1, 1fr);
    padding: 20px 1rem 0;

    .product:nth-child(2) {
      margin-top: 0;
    }

    .product:nth-child(3) {
      margin-top: 0;
    }
  }
`

export const Product = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
`

export const Title = styled.h3`
  font-size: 2.4rem;
  line-height: 1.2;
  margin-bottom: 0;
  margin-top: 0;

  @media (max-width: ${breakpoints.s}px) {
    line-height: 1;
    font-size: 26px;
  }
`

export const PriceTag = styled.span`
  font-weight: 300;
  font-size: 1rem;
  text-align: center;
  margin-top: 15px;

  :before {
    content: '- ';
  }
`
